<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12IxI74/tc-custom/9781616738433.jpg?1691029388820" alt="This image is the cover for the book Outnumbered"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Outnumbered
      </h1>
      <p class="bookDescription body article font2">
        <b>Fourteen dramatic stories of troops outnumbered but not outmatched—from Hannibal’s Carthaginians to the English at Agincourt to the Red Army in WWII.</b><br/><br/>Even a commander as fearless, self-assured, and battle-hardened as Alexander the Great, leading 40,000 Macedonian troops, must have quailed at the sight that met him as he neared the village of Issus, Asia Minor, in 333 BCE: an unexpectedly and unimaginably vast Persian force of some 100,000 men, spanning the Mediterranean coastal plain as far as the eye could see. For warfare had already demonstrated, and has confirmed ever since, that numerical superiority consistently carries the day. And yet, every once in a while, such lopsided engagements have had an unexpected outcome, and proved to be a crucible in which great leaders, and history, are forged.<br/><br/><i>Outnumbered</i> chronicles fourteen momentous occasions on which a smaller, ostensibly weaker force prevailed in an epochal confrontation. Thus, Alexander, undaunted, devised a brilliant and daring plan that disoriented and destroyed the Persian force and, consequently, its empire. Likewise, during the US Civil War, Confederate Gen. Robert E. Lee, despite being out-positioned and outnumbered more than two to one by Union forces at Chancellorsville, Virginia, hatched an audacious and surprise strategy that caught his enemy completely unawares. Other equally unexpected, era-defining victories are shown to have derived from the devastating deployment of unusual weaponry, sheer good fortune, or even the gullibility of an enemy, as when Yamashita Tomoyuki, commander of 35,000 ill-supplied Japanese troops, convinced the 85,000-strong British Commonwealth army to surrender Singapore in 1942.<br/><br/>Together these accounts constitute an enthralling survey that captures the excitement and terrors of battle, while highlighting the unpredictable nature of warfare and the courage and ingenuity of inspired, and inspiring, military leaders who, even when the odds seemed insurmountable, found a path to glory.<br/><br/>“There are similar titles about decisive battles and interesting campaigns, but none quite like this . . . an appealing choice for many military history enthusiasts.” —<i>Library Journal</i><br/><br/><i>Includes color illustrations and maps</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cormac O'Brien
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fair Winds Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f387d12